import * as Yup from 'yup';
export function validacionPago(tipo){
    switch (tipo) {
        case "TR":
            return [
                Yup.object({
                    forma_pago : Yup.string().required("Campo obligatorio"),
                }),
                Yup.object().shape({
                    contratacion : Yup.string().required("Campo obligatorio"),
                    desde : Yup.string().required("Campo obligatorio"),
                    hasta : Yup.string().required("Campo obligatorio"),
                    factura : Yup.boolean(),
                    ajuste : Yup.number().typeError('Monto real del pago'),
                    subtotal : Yup.number(),
                    total : Yup.number(),
                    id_caja : Yup.string().required("Campo obligatorio"),
                    concepto : Yup.string().ensure().when("cuentahabiente", {
                        is : val => !val || val === '',
                        then : (schema) => schema.required("Concepto o nombre de cuentahabiente obligatorio"),
                        otherwise : (schema) => schema.optional(),
                    }),
                    cuentahabiente : Yup.string().ensure().when("concepto", {
                        is : val => !val || val === '',
                        then : (schema) => schema.required("Concepto o nombre de cuentahabiente obligatorio"),
                        otherwise : (schema) => schema.optional(),
                    }),
                },[['concepto', 'cuentahabiente']])
            ]
        case "DE":
            return [
                Yup.object({
                    forma_pago : Yup.string().required("Campo obligatorio"),
                }),
                Yup.object().shape({
                    contratacion : Yup.string().required("Campo obligatorio"),
                    desde : Yup.string().required("Campo obligatorio"),
                    hasta : Yup.string().required("Campo obligatorio"),
                    factura : Yup.boolean(),
                    ajuste : Yup.number().typeError('Monto real del pago'),
                    subtotal : Yup.number(),
                    total : Yup.number(),
                    id_caja : Yup.string().required("Campo obligatorio"),
                    autorizacion : Yup.string().ensure().when('referencia',{
                        is: val => !val || val === '',
                        then : (schema) => schema.matches(/^[0-9]+$/, "Solo números").required("Número de autorización o referencia obligatorio"),
                        otherwise : (schema) => schema.optional(),
                    }),
                    referencia : Yup.string().ensure().when("autorizacion", {
                        is : val => !val || val === '',
                        then : (schema) => schema.required("Número de autorización o referencia obligatorio"),
                        otherwise : (schema) => schema.optional(),
                    })
                },[['autorizacion', 'referencia']])
            ]
        case "EF":
            return [
                Yup.object({
                    forma_pago : Yup.string().required("Campo obligatorio"),
                }),
                Yup.object().shape({
                    contratacion : Yup.string().required("Campo obligatorio"),
                    desde : Yup.string().required("Campo obligatorio"),
                    hasta : Yup.string().required("Campo obligatorio"),
                    factura : Yup.boolean(),
                    ajuste : Yup.number().typeError('Monto real del pago'),
                    subtotal : Yup.number(),
                    total : Yup.number(),
                    id_caja : Yup.string().required("Campo obligatorio"),
                })
            ]
        case "CO":
            return [
                Yup.object({
                    forma_pago : Yup.string().required("Campo obligatorio"),
                }),
                Yup.object().shape({
                    contratacion : Yup.string().required("Campo obligatorio"),
                    desde : Yup.string().required("Campo obligatorio"),
                    hasta : Yup.string().required("Campo obligatorio"),
                    factura : Yup.boolean(),
                    ajuste : Yup.number().typeError('Monto real del pago'),
                    subtotal : Yup.number(),
                    total : Yup.number(),
                    id_caja : Yup.string().required("Campo obligatorio"),
                    autorizacion : Yup.string().matches(/^[0-9]+$/, "Solo números").required("Campo obligatorio"),
                })
            ];
        case "TE":
            return [
                Yup.object({
                    forma_pago : Yup.string().required("Campo obligatorio"),
                }),
                Yup.object().shape({
                    contratacion : Yup.string().required("Campo obligatorio"),
                    desde : Yup.string().required("Campo obligatorio"),
                    hasta : Yup.string().required("Campo obligatorio"),
                    factura : Yup.boolean(),
                    ajuste : Yup.number().typeError('Monto real del pago'),
                    subtotal : Yup.number(),
                    total : Yup.number(),
                    id_caja : Yup.string().required("Campo obligatorio"),
                    tarjeta : Yup.string().required("Campo obligatorio"),
                })
            ];
        default:
            return [
                Yup.object({
                    forma_pago : Yup.string().required("Campo obligatorio"),
                }),
                Yup.object().shape({
                    contratacion : Yup.string().required("Campo obligatorio"),
                    desde : Yup.string().required("Campo obligatorio"),
                    hasta : Yup.string().required("Campo obligatorio"),
                    factura : Yup.boolean(),
                    ajuste : Yup.number().typeError('Monto real del pago'),
                    subtotal : Yup.number(),
                    total : Yup.number(),
                    id_caja : Yup.string().required("Campo obligatorio"),
                    sucursal : Yup.string().required("Campo obligatorio"),
                })
            ];
    }
}
